"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declareIdentifierType = exports.getVariableType = exports.assignFunctionType = exports.setFunctionParams = void 0;
const constants_1 = require("../constants");
const errors = require("../errors/errors");
const errors_1 = require("../interpreter/errors");
const typeEnvironment_1 = require("./typeEnvironment");
function setFunctionParams(node, context, name, params) {
    let environment = (0, typeEnvironment_1.currentTypeEnvironment)(context);
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            environment.head[name] = params;
            return;
        }
        else {
            environment = environment.tail;
        }
    }
    return (0, errors_1.handleRuntimeError)(context, new errors.UndefinedVariable(name, context.runtime.nodes[0]));
}
exports.setFunctionParams = setFunctionParams;
function assignFunctionType(node, context, name, functionClosure) {
    const environment = (0, typeEnvironment_1.currentTypeEnvironment)(context);
    environment.head[name] = functionClosure;
}
exports.assignFunctionType = assignFunctionType;
function getVariableType(context, name) {
    let environment = (0, typeEnvironment_1.currentTypeEnvironment)(context);
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            return environment.head[name];
        }
        else {
            environment = environment.tail;
        }
    }
    return (0, errors_1.handleRuntimeError)(context, new errors.UndefinedVariable(name, context.runtime.nodes[0]));
}
exports.getVariableType = getVariableType;
function declareIdentifierType(context, name, node) {
    const typeEnvironment = (0, typeEnvironment_1.currentTypeEnvironment)(context);
    if (typeEnvironment.head.hasOwnProperty(name)) {
        return (0, errors_1.handleRuntimeError)(context, new errors.ExceptionError(new Error('Redeclared'), node.loc));
    }
    if (node.type == 'VariableDeclarationExpression') {
        typeEnvironment.head[name] = constants_1.typeMappings[node.identifierType.valueType];
    }
    else if (node.type == 'ArrayDeclarationExpression') {
        typeEnvironment.head[name] = constants_1.typeMappings[node.arrayType.valueType];
    }
    else if (node.type == 'PointerDeclarationExpression') {
        typeEnvironment.head[name] = constants_1.typeMappings[node.pointerType.valueType];
    }
    return typeEnvironment;
}
exports.declareIdentifierType = declareIdentifierType;
//# sourceMappingURL=utils.js.map